import React from 'react';

function NewMexico({handleClick, className}) {
  return (
    <path onClick={handleClick} className={className} id="NM" d="M270.2 429.4l-16.7-2.6-1.2 9.6-15.8-2 6-39.7 7-53.2 4.4-30.9 34 3.9 37.4 4.4 32 2.8-.3 10.8-1.4-.1-7.4 97.7-28.4-1.8-38.1-3.7.7 6.3z"><title>New Mexico</title></path>
  );
}

export default NewMexico;
